import { ga4 } from '@domain-group/fe-co-allhomes-analytics';
export var dreamHomeClickEvent = _ref => {
  var listPosition = _ref.listPosition,
    listingCategory = _ref.listingCategory,
    suburb = _ref.suburb,
    state = _ref.state,
    elementText = _ref.elementText;
  return ga4.ga4event('cta_driver', {
    element_list_name: 'Dream homes',
    element_list_position: "".concat(listPosition + 1),
    element_position: 'middle',
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Listing',
    element_type: 'widget',
    element_title: "".concat(suburb, ", ").concat(state),
    element_text: elementText
  });
};
export var propertyOfTheWeekClickEvent = _ref2 => {
  var listPosition = _ref2.listPosition,
    listingCategory = _ref2.listingCategory,
    listingAddress = _ref2.listingAddress;
  return ga4.ga4event('cta_driver', {
    element_list_name: 'Property of the Week',
    element_list_position: "".concat(listPosition + 1),
    element_position: 'middle',
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Listing',
    element_type: 'widget',
    element_text: listingAddress
  });
};
export var autocompleteSearchEvent = _ref3 => {
  var searchTerm = _ref3.searchTerm,
    listingCategory = _ref3.listingCategory;
  return ga4.ga4event('search', {
    element_list_name: 'Autocomplete search',
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Search Page',
    element_type: 'search icon',
    search_term: searchTerm
  });
};
export var recentSearchEvent = _ref4 => {
  var recentSearchPosition = _ref4.recentSearchPosition,
    label = _ref4.label,
    listingCategory = _ref4.listingCategory;
  return ga4.ga4event('search', {
    element_list_name: 'recent searches',
    element_list_position: "".concat(recentSearchPosition + 1),
    element_target_category_primary: listingCategory,
    element_target_page_type: 'Search Page',
    element_text: label,
    element_type: 'button'
  });
};
export var exploreSuburbProfiles = _ref5 => {
  var ctaText = _ref5.ctaText,
    subtitle = _ref5.subtitle;
  return ga4.ga4event('cta_driver', {
    element_list_name: 'Suburb profiles and past sales',
    element_list_position: '1',
    element_position: 'middle',
    element_target_category_primary: 'Research',
    element_target_page_type: 'Index',
    element_text: ctaText,
    element_title: subtitle,
    element_type: 'button'
  });
};
export var viewDistrictProfile = _ref6 => {
  var listPosition = _ref6.listPosition,
    ctaText = _ref6.ctaText,
    districtName = _ref6.districtName;
  return ga4.ga4event('cta_driver', {
    element_list_name: 'Suburb profiles and past sales',
    element_list_position: "".concat(listPosition + 2),
    element_position: 'middle',
    element_target_category_primary: 'Research',
    element_target_page_type: 'Index',
    element_text: ctaText,
    element_title: districtName,
    element_type: 'button'
  });
};